import LoginView from './Login.view';
export * from './Login.view';

export const Login = (props) => LoginView(props);

export default Login;

